<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <div class="add-to-portfolio">
        <Portal v-if="instruments" to="breadcrumb_addRateShareToPortfolio">
          Zu Portfolio hinzufügen
        </Portal>

        <fin-add-to-portfolio :instruments="instruments"
                              :title="title"
                              :to="to"
                              @addToPortfolioDone="$emit('addToPortfolioDone')"/>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinAddToPortfolio from '@/components/common/portfolio/AddToPortfolio/index'
import FinDataLoader from "@/components/common/DataLoader"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {
  getMinimalShareForAddToPortfolio,
  getMinimalShareRatingForAddToPortfolio
} from "@/views/protected/finTools/rate/shares/graphql"

export default {
  name: 'FinRateShareAddToPortfolio',
  components: {
    FinDataLoader,
    FinAddToPortfolio
  },
  props: {
    /* Set via router - tool id */
    srId: {
      type: String
    },
    /* Set via router - share id */
    sid: {
      type: String
    },
  },
  data() {
    return {
      title: 'Wertpapier zu Portfolio hinzufügen',
      instruments: [],
      instrumentId: undefined,
      to: {name: this.srId ? 'finToolsRateSharesRatingExec' : 'finToolsRateSharesRatingCreate', params: {id: this.srId}}
    }
  },
  methods: {
    async loadData() {
      console.log("this.srId", this.srId)
      console.log("this.sid", this.sid)

      try {
        // add to portfolio called from exec page
        if (this.srId && this.srId.length > 0) {
          let result = await API.graphql(graphqlOperation(getMinimalShareRatingForAddToPortfolio, {
            id: this.srId
          }))

          if (result.data.getShareRating === null) {
            throw new Error('No share found by given id ' + this.sid)
          }
          this.instruments.push(result.data.getShareRating.share)
        }
        // add to portfolio called from create-rating page
        else if (this.sid) {
          let result = await API.graphql(graphqlOperation(getMinimalShareForAddToPortfolio, {
            instrumentId: this.sid.toUpperCase()
          }))
          const resultData = result.data.getShare
          if (resultData === null) {
            throw new Error('No share found by given id ' + this.sid)
          }
          this.instruments.push(resultData)
        }
      } catch (error) {
        console.error("error loading share for adding to portfolio from share rate", error, this.srId, this.sid)
        await this.$router.push(this.to)
        this.$toasted.global.finToast({
          message: 'Es konnten nicht alle benötigten Daten geladen werden. Bitte versuche es erneut.',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-portfolio {
  background-color: #fff;
}
</style>
